// extracted by mini-css-extract-plugin
export var divider = "_nz-0";
export var systemMessage = "_nz-1";